import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentRoutingModule } from './agent-routing.module';
import { FormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgSelectModule } from '@ng-select/ng-select';
import { JobSaveComponent } from './components/job-save/job-save.component';
import { JobListComponent } from './components/job-list/job-list.component';
import { AgentApplicationListComponent } from './components/application-list/application-list.component';
import { SharedPanelModule } from '../shared-panel/shared-panel.module';
import { SharedModule } from '../shared/shared.module';
import { AdminModule } from '../admin/admin.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CoreModule } from 'src/app/core/core.module';

const shared = [JobSaveComponent, JobListComponent, AgentApplicationListComponent];
@NgModule({
  declarations: shared,
  imports: [
    CommonModule,
    AgentRoutingModule,
    FormsModule,
    CoreModule,
    SharedModule,
    SharedPanelModule,
    AdminModule,
    AngularEditorModule,
    NgxSmartModalModule,
    NgSelectModule,
    ScrollingModule
  ],
  exports: shared
})
export class AgentModule { }
